// removed by extract-text-webpack-plugin
module.exports = {"new-module-button":"style__new-module-button___2Kaye","module-title":"style__module-title___3euXO","module-container":"style__module-container___18xII","module":"style__module___owzDi","module-actions-panel":"style__module-actions-panel___1uufy","edit-module":"style__edit-module___l3JwL","delete-module":"style__delete-module___1RI3j","module-name--to-delete":"style__module-name--to-delete___LGopz"};


//////////////////
// WEBPACK FOOTER
// ./components/AdminModulePage/style.scss
// module id = 1331
// module chunks = 0